import * as types from '@/store/mutation-types';

const getters = {
  orders: state => state.orders,
};

const actions = {
  async orderShafts({ dispatch, commit, getters }, payload) {
    try {
      if (!payload || payload.length === 0) return;
      await this._vm.$directus.transport.post('/shafts/order', {
        shafts: payload.shafts,
        delivery_date: payload.deliveryDate,
      });
      // mark as ordered immediately
      payload.shafts.forEach(shaft => {
        shaft.ordered = true;
        shaft.order_user = getters.user;
        shaft.order_date = new Date();
      });
      // afterwards refresh all the data
      dispatch('getSites');
      dispatch('getLatestShafts');
      dispatch('getOrders');
      if (getters.currentShaft)
        dispatch('getCurrentShaft', getters.currentShaft.id);
    } catch (error) {
      //console.error(error);
      commit(types.SHOW_ERROR, error.message);
    }
  },
  async getOrders({ commit }) {
    try {
      const shafts = this._vm.$directus.items('shafts');
      const shaftsData = await shafts.readByQuery({
        filter: { ordered: { _eq: true } },
        sort: '-order_date',
        fields: '*.*.*',
      });

      const groups = [];
      shaftsData.data.forEach(shaft => {
        if (shaft.site_id) {
          var group = groups.find(g => g.order_key === shaft.order_key);
          if (!group) {
            group = {
              order_key: shaft.order_key,
              delivery_date: shaft.delivery_date,
              shafts: [],
            };
            groups.push(group);
          }
          group.site_id = shaft.site_id;
          group.order_date = shaft.order_date;
          group.order_user = shaft.order_user;
          group.user_updated = shaft.user_updated;
          group.shafts.push(shaft);
        }
      });

      commit(types.SET_ORDERS, groups);
    } catch (error) {
      //console.error(error);
      commit(types.SHOW_ERROR, error.message);
    }
  },
  async getOrderSummary({ commit }, payload) {
    try {
      const summary = await this._vm.$directus.transport.get(
        '/orders/summary?order_key=' + payload,
      );
      return summary.raw;
    } catch (error) {
      //console.error(error);
      commit(types.SHOW_ERROR, error.message);
    }
  },
};

const mutations = {
  [types.SET_ORDERS](state, orders) {
    state.orders = orders;
  },
};

const state = {
  orders: [],
};

export default {
  state,
  getters,
  actions,
  mutations,
};
